import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const defaultState = {
  isOpen: false,
  isHeaderFix: false,
  product: {
    page: 0,
    pageSize: 20,
    productList: [],
    last: false,
    totalCount: 0
  },
  tag: {
    tagList: [],
    totalCount: 0
  }
}

export default {
  namespaced: true,
  state: defaultState,
  actions,
  getters,
  mutations
}